export default __webpack_public_path__ + "static/media/IMG_6035 copie.f9d8cbc6.jpg";